import React from "react";
import "./PortfolioIntroduction.css";

// Reutiliza o estilo da introdução do Portfólio, para as duas páginas
// interiores ficarem coerentes.
const ServicesIntroduction = () => {
  return (
    <section className="portfolioIntroSection">
      <div className="container">
        <p>
          Na vanguarda da inovação em engenharia, oferecemos soluções precisas e
          eficientes para impulsionar os seus projetos.
        </p>
        <p>
          A Cubic assume o compromisso com a qualidade dos serviços prestados,
          aliando rigor técnico, capacidade de inovação e uma resposta sólida
          nas diversas áreas da engenharia em que atua.
        </p>
      </div>
    </section>
  );
};

export default ServicesIntroduction;
